// Whether a camera picture is blank: all black, flat, or a camera-off / blocked icon on a plain
// background. Same rule as the exam photos (ImageProctoring.jsx) and the video backend's
// blankFrame.js: a 44x36 thumbnail with luma variance under 1.5, or at least 90% of it within 12
// of its median grey. Real photos score at most 0.07 on that share (staging 23 Oct and HDFC 24 Oct
// 2026, 147 photos); a blocked camera 0.94-0.99.
const VARIANCE_THRESHOLD = 1.5;
const MIN_UNIFORM = 0.9;
const NEAR = 12;

// dataUrl: a picture from the camera (data: URL). Resolves false when it can't be read, so a
// browser problem here never counts as a blank camera.
export const isBlankFrame = (dataUrl) =>
  new Promise((resolve) => {
    if (!dataUrl) return resolve(false);
    const img = new Image();
    img.onload = () => {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = 44;
        canvas.height = 36;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        const data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
        const lumas = [];
        let sum = 0, sumSq = 0;
        for (let i = 0; i < data.length; i += 4) {
          const luma = (data[i] + data[i + 1] + data[i + 2]) / 3;
          lumas.push(luma);
          sum += luma;
          sumSq += luma * luma;
        }
        const mean = sum / lumas.length;
        const variance = sumSq / lumas.length - mean * mean;
        lumas.sort((a, b) => a - b);
        const median = lumas[lumas.length >> 1];
        const uniform = lumas.filter((l) => Math.abs(l - median) <= NEAR).length / lumas.length;
        resolve(variance < VARIANCE_THRESHOLD || uniform >= MIN_UNIFORM);
      } catch (e) {
        resolve(false);
      }
    };
    img.onerror = () => resolve(false);
    img.src = dataUrl;
  });
